module.exports = __webpack_public_path__ + "static/2-f94ed71cef17f5f30bbe80202c8c38c4.png";